import initialState from './initialState';
import { types } from '../actions/budgetAccountsActions';
import { types as authTypes } from '../actions/budgetAuthActions';

export default function budgetAccountReducer(state = initialState.budgetAccount, action) {
  const { data } = action;
  switch (action.type) {
    case authTypes.BUDGET_CURRENT_USER_DATA_SUCCESS: {      
      return { fetching: false, data };
    }
    case authTypes.BUDGET_CURRENT_USER_DATA: {
      return { fetching: true, data: null };
    }
    case authTypes.BUDGET_CURRENT_USER_DATA_FAILURE: {
      return { 
        fetching: false, 
        data: null,
      };
    }
    case types.BUDGET_UPDATE_ACCOUNT_SUCCESS: {      
      return { 
        fetching: false, 
        data,
      };
    }    
    case types.BUDGET_UPDATE_SETTINGS_SUCCESS: {
      let participantAccount = {...state.data};
      participantAccount.settings = data.settings;
      return { 
        fetching: false, 
        data: participantAccount,
      };
    }
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/budgetAccountReducer.js